import React, { useState } from 'react';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import { RetailModel } from './RetailModel';

type Props = {
  className: string;
  title: string;
  description: string;
  avatar: string;
  link: string | undefined;
};

const RetailWidget: React.FC<Props> = ({ className, title, description, avatar, link }) => {
  const [modalShow, setModalShow] = useState(false);
  

  return (
    <div style={{ padding: 0 }}>
      <div className={`hoverable`} role="button" onClick={() => setModalShow(true)} style={{ cursor: 'pointer' }}>
        <img src={toAbsoluteUrl('/media/partner/retail.png')} width="100%" alt='Logo' className='card-p-5 shadow' style={{ borderRadius: 8 }} />
      </div>
      <RetailModel show={modalShow} handleClose={() => setModalShow(false)} />
    </div>
  );
};

export { RetailWidget };
